import React from "react";
import { Link } from "react-router-dom";
import withCustomStyles from "./SubcategoryBannerPart.style";
import { getUrlPath } from "../utils/UrlUtils";

const SubcategoryBannerPart = ({ banner, classes }) => {
  if (!banner || !banner.banner_image) {
    return null;
  }

  const image = (
    <img
      width="1000"
      height="333"
      src={banner.banner_image}
      alt="Banner"
      className={classes.image}
    />
  );

  if (!banner.landing_page) {
    return <div className={classes.root}>{image}</div>;
  }

  if (banner.landing_page.startsWith("https://grocerapp.pk")) {
    return (
      <div className={classes.root}>
        <Link to={getUrlPath(banner.landing_page)}>{image}</Link>
      </div>
    );
  }

  return (
    <div className={classes.root}>
      <a href={banner.landing_page}>{image}</a>
    </div>
  );
};

export default withCustomStyles(SubcategoryBannerPart);
